var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.0100873C21.0424 0.687685 19.9821 1.20594 18.86 1.54489C18.2577 0.850227 17.4573 0.357867 16.567 0.134402C15.6767 -0.0890626 14.7395 -0.0328515 13.8821 0.295433C13.0247 0.623718 12.2884 1.20824 11.773 1.96994C11.2575 2.73163 10.9877 3.63376 11 4.55431V5.55744C9.24263 5.60316 7.50127 5.21218 5.93101 4.41933C4.36074 3.62648 3.01032 2.45638 2 1.01323C2 1.01323 -2 10.0415 7 14.054C4.94053 15.4564 2.48716 16.1595 0 16.0603C9 21.076 20 16.0603 20 4.52421C19.9991 4.24479 19.9723 3.96606 19.92 3.69161C20.9406 2.68194 21.6608 1.40717 22 0.0100873Z",
    fill: "#07264A"
  })));
};

export default SvgTwitterinline;